import VueScrollTo from 'vue-scrollto'

export function setupAnnotations () {
  this.$nextTick(() => {
    let count = 1
    const footnotes = document.getElementById('footnotes')
    while (footnotes.firstChild) {
      footnotes.firstChild.remove()
    }

    const annotations = document.querySelectorAll('.annotation')

    for (let annotation of annotations) {
      const counters = [...annotation.getElementsByClassName('annotation-counter')]
      const ring = annotation.getElementsByClassName('annotation-ring')[0]
      annotation.getElementsByClassName('annotation-target')[0].setAttribute('id', `annotation-${count}`)
      ring.setAttribute('id', `annotation-ring-${count}`)
      counters.forEach(x => {
        x.innerText = count
      })
      const annotationCopy = annotation.cloneNode(true)
      const footnoteLink = document.createElement('a')
      footnoteLink.classList.add('annotation-link')
      footnoteLink.setAttribute('href', `#annotation-${count}`)
      footnoteLink.innerText = '⤴'
      const annotationId = `annotation-ring-${count}`
      footnoteLink.addEventListener('click', (e) => {
        e.preventDefault()
        const el = document.getElementById(annotationId)
        VueScrollTo.scrollTo(el, 150, {
          easing: 'ease-out',
          offset: -250
        })
        el.classList.remove('animate')
        setTimeout(() => {
          el.classList.add('animate')
        }, 100)
      })
      annotationCopy.appendChild(footnoteLink)
      footnotes.appendChild(annotationCopy)
      ring.addEventListener('click', (e) => {
        e.preventDefault()
        const el = footnoteLink
        VueScrollTo.scrollTo(el, 150, {
          easing: 'ease-out',
          offset: -250
        })
      })
      count = count + 1
    }

    adjustAnnotations()

    this.hasFootnotes = annotations.length
  })
}

export function cumulativeOffset (element) {
  var top = 0
  var left = 0

  do {
    top += element.offsetTop || 0
    left += element.offsetLeft || 0
    element = element.offsetParent
  } while (element)

  return {
    top: top,
    left: left
  }
}

export function adjustAnnotations () {
  const annotations = document.querySelectorAll('.text-block span.annotation-content')
  const minOffset = 16

  if (annotations.length > 1) {
    let counter = 0
    for (const annotation of annotations) {
      if (counter > 0) {
        const prev = annotations[counter - 1]
        const prevBottom = cumulativeOffset(prev).top + prev.clientHeight + minOffset
        const currentTop = cumulativeOffset(annotation).top

        if (currentTop < prevBottom) {
          const newTop = prevBottom - currentTop
          annotation.style.paddingTop = `${newTop}px`
        }
      }
      counter++
    }
  }
}

export function relativeUrl (link = '') {
  if ('URL' in window) {
    const u = new URL(link)
    return u.href.replace(u.origin, '')
  }
  return link.replace(window.location.origin, '')
}
